import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client'; // Usando a nova API do React 18
import App from './App';
import './index.css'; // Importa o arquivo de estilos globais
import { BrowserRouter as Router } from 'react-router-dom'; // Importa o Router para o roteamento
//import { AuthProvider } from './hooks/useAuthProvider'; // Importa o AuthProvider
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from "./context/ThemeContext";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import { PlanProvider } from "./context/PlanContext";
import { LembretesProvider } from "./context/LembretesContext";
import { TimerProvider } from "./context/TimerContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root')); // Cria o root para renderização

root.render(
  <React.StrictMode>
    <Router >
      <AuthProvider>
        <PlanProvider>
          <WorkspaceProvider>
            <LembretesProvider>
              <TimerProvider>
                <ThemeProvider>
                  <App />
                </ThemeProvider>
              </TimerProvider>
            </LembretesProvider>
          </WorkspaceProvider>
        </PlanProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

// Necessario para offline e, principalmente, para o push dos lembretes.
serviceWorkerRegistration.register();
